function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _is_native_reflect_construct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _create_super(Derived) {
    var hasNativeReflectConstruct = _is_native_reflect_construct();
    return function _createSuperInternal() {
        var Super = _get_prototype_of(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _get_prototype_of(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possible_constructor_return(this, result);
    };
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { Component } from "react";
import { connect } from "react-redux";
import { CSSTransition } from "react-transition-group";
import { closeModal } from "@common/actions";
import SideBarMenu from "@common/components/SideBarMenu";
import Invoices from "@common/components/account/invoices/Invoices";
import ChangePassword from "@common/components/account/profile/ChangePassword";
import DeleteAccount from "@common/components/account/profile/DeleteAccount";
import CancelSubscription from "@common/components/account/subscription/CancelSubscription";
import CancelSubscriptionFinalStep from "@common/components/account/subscription/CancelSubscriptionFinalStep";
import ContinueSubscription from "@common/components/account/subscription/ContinueSubscription";
// TODO: move import to common when telekabel shopping cart transition is done
import Payment from "@components/account/payment/Payment";
// TODO: move import to common when telekabel shopping cart transition is done
import ProfileInformation from "@components/account/profile/ProfileInformation";
// TODO: move import to common when telekabel shopping cart transition is done
import Subscription from "@components/account/subscription/Subscription";
import { ACCOUNT_TABS, ANIMATION_TIMEOUT, CANCEL_SUBSCRIPTION, CANCEL_SUBSCRIPTION_FINAL_STEP, CHANGE_PASSWORD, CONTINUE_SUBSCRIPTION, DELETE_ACCOUNT, INVOICES, PAYMENTS, PROFILE_INFORMATION, SUBSCRIPTION } from "@config/constants";
var Account = /*#__PURE__*/ function(Component) {
    "use strict";
    _inherits(Account, Component);
    var _super = _create_super(Account);
    function Account(props) {
        _class_call_check(this, Account);
        var _this;
        _this = _super.call(this, props);
        _this.state = {
            activeComponentName: null,
            additionalProps: null,
            show: true,
            exitLeft: false,
            exitRight: false,
            isOpenedFromNotification: false
        };
        _this.focusTimeout = null;
        _this.wrapperRef = null;
        _this.toggleComponent = _this.toggleComponent.bind(_assert_this_initialized(_this));
        _this.closeAccountModal = _this.closeAccountModal.bind(_assert_this_initialized(_this));
        return _this;
    }
    _create_class(Account, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _this = this;
                this.focusTimeout = setTimeout(function() {
                    _this.wrapperRef.focus();
                }, 0);
                if (this.props.initialComponent) {
                    // this.toggleComponent(this.props.initialComponent, {
                    //     shouldToggleWithTransition: true,
                    //     isOpenedFromNotification: true,
                    // });
                    this.setState({
                        activeComponentName: this.props.initialComponent
                    });
                }
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                clearTimeout(this.focusTimeout);
            }
        },
        {
            /**
     *  Toggle the active component by setting its name as activeComponentName
     *  which is then mapped to COMPONENT_MAP component objects
     *  @param {string} component
     */ key: "toggleComponent",
            value: function toggleComponent(component, additionalProps) {
                var _this = this;
                var exitLeft = additionalProps ? additionalProps.exitLeft : false;
                var exitRight = additionalProps ? additionalProps.exitRight : false;
                var timeout = additionalProps ? ANIMATION_TIMEOUT : 0;
                if (additionalProps && additionalProps.isOpenedFromNotification) {
                    this.setState(function() {
                        return {
                            isOpenedFromNotification: true
                        };
                    });
                }
                this.setState(function() {
                    return {
                        exitLeft: exitLeft,
                        exitRight: exitRight,
                        show: !_this.state.show
                    };
                });
                setTimeout((function() {
                    var _this = this;
                    this.setState(function() {
                        return {
                            activeComponentName: component,
                            additionalProps: additionalProps,
                            show: !_this.state.show
                        };
                    });
                }).bind(this), timeout);
                window.scrollTo(0, 1);
            }
        },
        {
            /**
     * Closes the account modal and if it is opened from notification
     * permanently closes the notification too
     */ key: "closeAccountModal",
            value: function closeAccountModal() {
                this.props.closeModal();
                if (this.state.isOpenedFromNotification) {
                    this.props.closeNotifications(true);
                }
            }
        },
        {
            key: "render",
            value: function render() {
                var _this = this;
                var _this_props = this.props, i18n = _this_props.i18n, userDetails = _this_props.userDetails, initialComponent = _this_props.initialComponent, screenType = _this_props.screenType, onlyChangePassword = _this_props.onlyChangePassword;
                var _this_state = this.state, _activeComponentName = _this_state.activeComponentName, additionalProps = _this_state.additionalProps, exitLeft = _this_state.exitLeft, exitRight = _this_state.exitRight;
                var _obj;
                // here we describe every component in the account modal
                // and from this map we get the component that is toggled
                var COMPONENT_MAP = (_obj = {}, _define_property(_obj, PROFILE_INFORMATION, {
                    component: ProfileInformation,
                    componentName: PROFILE_INFORMATION,
                    title: i18n.tooltips.profile,
                    iconClassNames: "icon icon-account-circle",
                    childProps: {
                        shouldToggleWithTransition: true
                    }
                }), _define_property(_obj, DELETE_ACCOUNT, {
                    component: DeleteAccount,
                    componentName: DELETE_ACCOUNT,
                    title: i18n.account.deleteAccount,
                    parentComponentName: PROFILE_INFORMATION,
                    parentComponent: ProfileInformation,
                    parentProps: {
                        shouldToggleWithTransition: true,
                        enterFromLeft: true
                    }
                }), _define_property(_obj, CHANGE_PASSWORD, {
                    component: ChangePassword,
                    componentName: CHANGE_PASSWORD,
                    parentComponentName: PROFILE_INFORMATION,
                    parentComponent: ProfileInformation,
                    title: i18n.account.changePassword,
                    parentProps: {
                        shouldToggleWithTransition: true,
                        enterFromLeft: true,
                        onlyChangePassword: onlyChangePassword
                    }
                }), _define_property(_obj, PAYMENTS, {
                    component: Payment,
                    componentName: PAYMENTS,
                    title: i18n.account.payment,
                    iconClassNames: "icon icon-payment"
                }), _define_property(_obj, SUBSCRIPTION, {
                    component: Subscription,
                    componentName: SUBSCRIPTION,
                    title: i18n.account.subscription,
                    iconClassNames: "icon icon-abonaments",
                    childProps: {
                        shouldToggleWithTransition: true,
                        exitLeft: true
                    }
                }), _define_property(_obj, INVOICES, {
                    title: i18n.account.invoices,
                    iconClassNames: "icon icon-pdf-2",
                    component: Invoices,
                    componentName: INVOICES,
                    hasScrollBar: true
                }), _define_property(_obj, CANCEL_SUBSCRIPTION, {
                    component: CancelSubscription,
                    componentName: CANCEL_SUBSCRIPTION,
                    parentComponentName: SUBSCRIPTION,
                    parentComponent: Subscription,
                    mainComponent: SUBSCRIPTION,
                    title: i18n.account.cancelSubscription,
                    parentProps: {
                        shouldToggleWithTransition: true,
                        enterFromLeft: true,
                        exitRight: true
                    },
                    childProps: {
                        shouldToggleWithTransition: true,
                        exitLeft: true
                    }
                }), _define_property(_obj, CANCEL_SUBSCRIPTION_FINAL_STEP, {
                    component: CancelSubscriptionFinalStep,
                    componentName: CANCEL_SUBSCRIPTION_FINAL_STEP,
                    parentComponentName: CANCEL_SUBSCRIPTION,
                    mainComponent: SUBSCRIPTION,
                    parentComponent: CancelSubscription,
                    title: i18n.account.cancelSubscription,
                    parentProps: {
                        shouldToggleWithTransition: true,
                        enterFromLeft: true
                    }
                }), _define_property(_obj, CONTINUE_SUBSCRIPTION, {
                    component: ContinueSubscription,
                    componentName: CONTINUE_SUBSCRIPTION,
                    parentComponentName: SUBSCRIPTION,
                    mainComponent: SUBSCRIPTION,
                    parentComponent: Subscription,
                    title: i18n.account.continueSubscription,
                    parentProps: {
                        shouldToggleWithTransition: true,
                        enterFromLeft: true
                    }
                }), _obj);
                // Here we pass configuration data for the sidebar menu
                // Making tabs from the components we need
                var sideMenuTabs = onlyChangePassword ? [
                    COMPONENT_MAP[CHANGE_PASSWORD]
                ] : ACCOUNT_TABS.map(function(tab) {
                    return COMPONENT_MAP[tab];
                });
                var activeComponentName = _activeComponentName || initialComponent || sideMenuTabs[0].componentName;
                var activeTabIndex = sideMenuTabs.findIndex(function(tab) {
                    return tab.componentName === activeComponentName;
                });
                var enterFromLeft = additionalProps ? additionalProps.enterFromLeft : false;
                var shouldToggleWithTransition = additionalProps ? additionalProps.shouldToggleWithTransition : false;
                var activeComponent = COMPONENT_MAP[activeComponentName];
                var _$Component = activeComponent.component;
                var hasScrollbar = activeComponent.hasScrollBar || false;
                var title = activeComponent.title;
                var iconClassNames = activeComponent.iconClassNames;
                var timeout = {
                    enter: ANIMATION_TIMEOUT,
                    exit: ANIMATION_TIMEOUT
                };
                var enterLeftClass = enterFromLeft ? " left-to-right-enter" : "";
                var enterRightClass = !enterFromLeft ? " right-to-left-enter" : "";
                var exitLeftClass = exitLeft ? " exit-left" : "";
                var exitRightClass = exitRight ? " exit-right" : "";
                var showOverflowClass = hasScrollbar ? " show-overflow" : "";
                var componentWrapperClasses = "toggled-content-wrapper".concat(enterLeftClass).concat(enterRightClass).concat(exitLeftClass).concat(exitRightClass).concat(showOverflowClass);
                return /*#__PURE__*/ _jsxs("div", {
                    tabIndex: "0",
                    ref: function(node) {
                        _this.wrapperRef = node;
                    },
                    className: "modal account-wrapper",
                    children: [
                        /*#__PURE__*/ _jsxs("div", {
                            className: "modal-header",
                            children: [
                                /*#__PURE__*/ _jsx("h2", {
                                    className: "modal-title",
                                    children: i18n.account.account
                                }),
                                /*#__PURE__*/ _jsx("span", {
                                    onClick: this.closeAccountModal,
                                    onKeyDown: this.closeAccountModal,
                                    className: "icon icon-clear pointer"
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx(SideBarMenu, {
                            sideMenuTabs: sideMenuTabs,
                            componentMap: COMPONENT_MAP,
                            activeTabIndex: activeTabIndex,
                            initialComponent: initialComponent,
                            toggleComponent: this.toggleComponent
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: "active-section-title",
                            children: [
                                activeComponentName && COMPONENT_MAP[activeComponentName].parentComponentName ? /*#__PURE__*/ _jsx("span", {
                                    className: "icon icon-arrow-back float-left",
                                    onClick: function() {
                                        return _this.toggleComponent(activeComponent.parentComponentName, activeComponent.parentProps);
                                    },
                                    onKeyDown: function() {
                                        return _this.toggleComponent(activeComponent.parentComponentName, activeComponent.parentProps);
                                    }
                                }) : null,
                                /*#__PURE__*/ _jsx("span", {
                                    className: iconClassNames
                                }),
                                /*#__PURE__*/ _jsx("span", {
                                    children: title
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "account-content float-right",
                            children: /*#__PURE__*/ _jsx("div", {
                                className: componentWrapperClasses,
                                children: /*#__PURE__*/ _jsx(CSSTransition, {
                                    timeout: timeout,
                                    in: this.state.show,
                                    classNames: "".concat(shouldToggleWithTransition ? "fade" : "fade-initial-component"),
                                    children: /*#__PURE__*/ _jsx(_$Component, {
                                        componentMap: COMPONENT_MAP,
                                        screenType: screenType,
                                        componentName: activeComponentName,
                                        shouldToggleWithTransition: shouldToggleWithTransition,
                                        toggleComponent: this.toggleComponent,
                                        additionalProps: additionalProps,
                                        i18n: i18n,
                                        tabIndex: "0",
                                        userDetails: userDetails
                                    })
                                })
                            })
                        })
                    ]
                });
            }
        }
    ]);
    return Account;
}(Component);
var mapStateToProps = function(param) {
    var i18n = param.i18n, userDetails = param.userDetails, screenType = param.screenType;
    return {
        i18n: i18n,
        userDetails: userDetails,
        screenType: screenType
    };
};
export default connect(mapStateToProps, {
    closeModal: closeModal
})(Account);
